<script>
import appConfig from "@/app.config";
import OrdersApi from "@/services/orders-api";
import Swal from "sweetalert2";



/**
 * Orders-list component
 */
export default {
  page: {
    title: "Bon de  Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
    orderId: {
      type: Number,
      default: 0,
    },
    isCatalogList: {
      type: Boolean,
      default: false,
    },
    showTransfer:{
      type: Boolean,
      default:null
    },

    showCashTotal:{
      type: Boolean,
      default:false
    },
  },

  watch: {
      'orderId': function(){
        this.getOrder();
    }
  },

  components: { },
  data() {
    return {
      
      isFakeOrderId:false,
      order: {lines:[], supplier:{city:{}, country:{}}, customer:{city:{}, country:{}},},
      
      //TODO to be replaced by constants !
      ORDER_STATUS_DRAFT: 0,
      ORDER_STATUS_SUBMITTED : 1,
      ORDER_STATUS_CONFIRMED : 2,

      previsionalDeliveryDate: null,

      //defaultCarrierName : 'Tunisia Express',
      defaultCarrierName : 'Fiabilo',
      lgpDeliveryModes: [{name:'Fournisseur lui-même', value: 0 }, {name:'Transporteur Fiabilo', value: 1}],
      deliveryMode: null,

      showCarrierModal: false,
      isOrderPending: false,
      role: null,

      cashPaymentTotalWithTaxes: null,
        
    };
  },  
  
    mounted() {
    
    this.getOrder();
    this.role=sessionStorage.getItem("userr");

    if (this.showCashTotal && ( (this.role == 1) || (this.role == 2) ) ) {
      this.getCashOrder();
    }
  },

    methods: {

    getPaymentLabel(days) {
      switch (days) {
        case 0:
          return 'Paiement au comptant';
        default:
          return 'Paiement à échéance';
      }
    },

    getPaymentMethod(paymentMethod) {
      switch (paymentMethod) {
        case 0:
          return 'Traite Bancaire'; // BILL_OF_EXCHANGE
        case 1:
          return 'Virement Bancaire'; // BANK_TRANSFER
        case 2:
          return 'Chèque'; // CHEQUE
        default:
          return '-';
      }
    },

    getOrder() {

      this.isFakeOrderId = this.orderId < 0
      OrdersApi.getOrder(this.orderId, this.showTransfer)
      .then(order => {
        this.order = order;
        this.deliveryMode = this.getDeliverMode(this.order);
      })

      .finally(() => {
      })
    },

    getCashOrder() {

      OrdersApi.getCashOnlyConsolidatedOrder(this.orderId, this.showTransfer)
      .then(cashOrder => {
        this.cashPaymentTotalWithTaxes = cashOrder.totalWithTaxes;
      })

      .finally(() => {
      })
    },

    getDeliverMode(order) {
      if (order && order.deliveryMode != null && (order.deliveryMode >= 0 || order.deliveryMode < 2)) {
        return this.lgpDeliveryModes[this.order.deliveryMode]
      } else {
        return null;
      }
    },

    priorityToLabel(priority) {
      switch(priority) {
        case 0: return 'Basse';
        case 1: return 'Normale';
        case 2: return 'Urgente';
        default: return 'Normale';
      }
    },

    priorityToColor(priority) {
      switch(priority) {
        case 0: return 'success';
        case 1: return 'secondary';
        case 2: return 'danger';
        default: return 'sacondary';
      }
    },

    statusToLabel(order) {
      if (order == null || order.status == null) {
        return '';
      }

      switch(order.status) {
        case 0: return 'Brouillon';
        case 1: return 'Nouvelle';
        case 2: return 'Confirmée'
        case 3: return order.isDeliveryDone ? 'Livré' : 'En cours de Livraison';
        case 4: return 'Annulée';
        default: return '';
      }
    },

    statusToColor(order) {
      switch(order.status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'warning';
        case 3: return order.isDeliveryDone ? 'success' : 'info';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

    resetConfirmedQuantity(line){

      if( !this.isFakeOrderId ){
        return
      }


      Swal.fire({
        html: `
          <p>Voulez-vous remettre la quantité confirmée à 0 pour la ligne :</p>
          <strong class="text-uppercase">${line.itemTitle} / ${line.ref}</strong>
          <p class="mt-2 text-danger text-uppercase">Cette action est irréversible.</p>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, confirmer !",
        cancelButtonText: "Annuler"
      })
            
      .then(result => {
        if (result.value) {

          OrdersApi.resetConfirmedQuantity(line.ref, this.orderId, this.showTransfer)
          .then(order => {
            this.order = order;
            this.deliveryMode = this.getDeliverMode(this.order);
          })

        }
      });
      



    },

    editConfirmedQuantity: function(line, index) {

      if( this.isFakeOrderId ){
        return
      }

      if (!this.order.isProcessable || this.order.status > 1) {
        return;
      }

      line.edit=true;
      let input = this.$refs['confirmedQuantityEdit-' + index][0];
      input.focus();
    },

    saveConfirmedQuantity(line) {

      if( this.isFakeOrderId ){
        return
      }

      if (line.confirmedQuantity == null) {
        line.confirmedQuantity = line.quantity
      }

      OrdersApi.saveConfirmedQuantity(line.id, line.confirmedQuantity)
        .then((order) => {
                line.edit=false;
                this.order = order;
                this.deliveryMode = this.getDeliverMode(this.order);
          })
    },

    confirm() {
      Swal.fire({
        title: "Voulez vous confirmer la commande ?",
        text: "Prière de vérifier les quantités avant de confirmer !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, confirmer !",
      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.confirmOrder(this.orderId, this.deliveryMode ? this.deliveryMode.value : null, this.order.parcelsNumber, this.order.invoiceAmountTaxIncl)
            .then((order) => {

              if (order) {
                this.order = order;
                this.deliveryMode = this.getDeliverMode(this.order);
              } 
            })
        }
      });
    },

    deliverOrder() {
      Swal.fire({
        title: "Commande prête pour la livraison ?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, confirmer !",

      })
      
      .then(result => {
        if (result.value) {

          this.isOrderPending = true;
          OrdersApi.deliverOrder(this.orderId, this.deliveryMode ? this.deliveryMode.value : null, this.order.parcelsNumber, this.order.invoiceAmountTaxIncl)
            .then((order) => {
              this.isOrderPending = false;
              if (order) {
                this.order = order;
                this.deliveryMode = this.getDeliverMode(this.order);

                if (this.deliveryMode.value == 1) {
                  Swal.fire("Livraison " + this.defaultCarrierName, "La livraison de cette commande sera prise en charge par " + this.defaultCarrierName + ". Veuillez imprimer le bordereau et le coller sur chaque colis !", "success");
                }
              }
            })
        }
      });
    },

    togglePaymentMode() {

        Swal.fire({
        title: "Changer le mode de Paiement ?",
        html: "Changer le mode de paiement de la commande.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Changer !",

      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.togglePaymentMode(this.orderId)
            .then((order) => {
              if (order) {
                this.order = order;
                this.deliveryMode = this.getDeliverMode(this.order);
              }
            })
        }
      });

    },

    cancelOrder() {
      Swal.fire({
        title: "Annuler la Commande ?",
        html: "La commande sera <strong class='text-danger'>définitivement annulée</strong>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Oui, Annuler !",

      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.cancelOrder(this.orderId, this.deliveryMode ? this.deliveryMode.value : null)
            .then((order) => {
              if (order) {
                this.order = order;
                this.deliveryMode = this.getDeliverMode(this.order);
              }
            })
        }
      });
    },

    downloadShipoxAwb() {
      if(this.order.carrierPdfLink){
        window.open(this.order.carrierPdfLink, "_blank");
        return;
      }
      //OrdersApi.downloadShipoxAwb(this.order.id)
      OrdersApi.downloadFParcelAwb(this.order.id)
      .then((awbUrl) => {
          if (awbUrl) {
            window.open(awbUrl, "_self"); 
          }
        })
    },

    exportEXCEL(orderId){
      OrdersApi.exportEXCEL(orderId)
    },

    
  }

}

</script>

<style>
.modal-dialog.modal-xl {
    min-width: 95% !important;
    min-height: 95% !important;
}

</style>

<template>
<div>
    <div v-if="!isCatalogList" class="row pt-4  d-print-none">
      

      <div class="col-md-6 col-sm-12 text-left " >
        <div class="form-group mb-3">
          <label>Etat de la commande</label><br>

          <h5><b-badge href="#" :variant="statusToColor(order)">{{statusToLabel(order)}}</b-badge></h5>
         
        </div>
      </div>

     <div class="col-md-6 col-sm-12 text-right ">
        <label>Moyen de Livraison</label>
        <p v-if="!order.isProcessable" class="text-primary font-weight-bold font-size-16"><i :class="order.deliveryMode != null ? (order.deliveryMode == 0 ? 'fas fa-users' : 'fas fa-truck' ) : ''" class=" mr-2" />{{order.deliveryMode != null ? this.getDeliverMode(order).name : '_'}}</p>

        <v-select v-if="order.isProcessable" class="style-vselect text-primary-important font-weight-bold font-size-16" v-model="deliveryMode" :options="lgpDeliveryModes"  style="font-size:16px; border: 2px solid #50a5f1; border-radius: 5px;" placeholder="Sélectionner un mode de livraison" label="name" :disabled="order.status > 2">
            <span slot="no-options">Aucun élément dans la liste</span>
        </v-select> 
      </div>

      <div class="col-md-2 col-sm-12 p-1 text-right d-print-none">
      </div>

    </div>

    <div class="row pb-4 d-print-none">
      

      <div class="col-6"/>
     

      <div v-if="this.deliveryMode != null && this.deliveryMode.value == 1" class="col-3 pr-2 text-right">
        <label>Nombre de Colis</label>
        <input    
          v-model="order.parcelsNumber"               
          type="number"
          class="form-control"
          min="1"
          :disabled="order.status > 2"
        />
      </div>

      <div v-if="this.deliveryMode != null && this.deliveryMode.value == 1" class="col-3 pl-2 text-right">
        <label>Facture - Total TTC</label>
        <input    
          v-model="order.invoiceAmountTaxIncl"               
          type="number"
          class="form-control"
          min="1"
          :disabled="order.status > 2"
        />
      </div>
     

      

     


    </div>
    
   
    <div class="row " v-if="!showCarrierModal">

      
      
      <div class="col-12">

        
        <div class="card border border-secondary no-border-on-print">
          <div class="card-body">
            <div  class="invoice-title">
              <h4 class="float-right text-primary font-size-16">BON DE COMMANDE N° <strong>{{order.ref}}</strong></h4>
              <div class="mb-4">
                <img v-bind:src="'/api/image/get/' + order.supplier.logo" alt="logo" height="40" />


                <!-- <img v-bind:src="'/api/image/get/' + order.supplier.logo" alt class="avatar-sm" style="height: 4rem;width: 7rem;border: 1px solid #a09999;padding: 10px;" /> -->



              </div>
            </div>
            <hr class="d-print-none" />
            <div class="row">
              <div  class="col-6">
                <address>
                  <strong>Fournisseur :</strong> {{this.order.supplier.legalName}}
                  <!-- <br /><strong>{{this.order.supplier.name}}</strong> -->
                  <br />{{this.order.supplier.address}}
                  <br />{{this.order.supplier.city.name}}, {{this.order.supplier.country.name}}
                  <br/><br /><i v-if="order.supplier.phone" class="fas fa-phone text-muted font-size-12"/> {{this.order.supplier.phone}}
                  <span v-if="order.supplier.secondPhone" class="font-size-12"> - {{this.order.supplier.secondPhone}}</span>
                  
                  <br />
                </address>
              </div>
              <div class="col-6 text-right">
                <address>
                  <strong>Client :</strong> {{this.order.customer.name}}
                  <!-- <br /><strong>{{this.order.customer.name}}</strong> -->
                  <br />{{this.order.customer.city.name}} - {{this.order.customer.country.name}}
                  <br /><i>{{this.order.customer.taxRefNumber ? 'MF : ' + this.order.customer.taxRefNumber : ''}} </i>
                  <br/><br /><i v-if="order.customer.phone" class="fas fa-phone text-muted font-size-12"/> {{this.order.customer.phone}}
                  <span v-if="order.customer.secondPhone" class="font-size-12"> - {{this.order.customer.secondPhone}}</span>
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>Date:</strong>
                  <br />{{order.submissionDate}}
                  
                </address>
              </div>
              <div class="col-6 mt-3 text-right">
                <address>
                  <strong>Adresse de Livraison :</strong>
                  <br />{{this.order.deliveryAddress}}
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-0">
                <address>
                  <span >{{this.getPaymentLabel(order.paymentDays)}}</span>
                  <a v-if="role==2" href="javascript: void(0);" @click="togglePaymentMode()"><i class="fas fa-sync-alt text-danger font-size-14 pl-1" title="Changer le mode de paiement"></i></a>
                  <div class="mt-2" >Paiement par  {{this.getPaymentMethod(order.paymentMethod)}}</div>
                  <br />
                  <br />
                </address>
              </div>
            </div>
            <!-- <div class="row" v-else>
              <div class="col-6 mt-3">
                <address>
                  <strong>Mode de Paiement : </strong>
                  <br />Paiement par virement bancaire à échénace
                  <br />
                  <br />
                </address>
              </div>
            </div> -->
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Commande</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 150px;">Référence</th>
                    <th style="width: 300px;">Article</th>
                    <th style="width: 250px;" class="text-right">P.U.</th>
                    <th style="width: 250px;" class="text-right">P.U. Remisé</th>
                    <th style="width: 120px;" class="text-right">Qté Cmdée</th>
                    <th style="width: 120px; background-color: rgb(191, 234, 255,0.5);" class="text-right">Qté Confirmée</th>
                    <th style="width: 250px;" class="text-right">Prix HT</th>
                    <th style="width: 100px;" class="text-right">Remise %</th>
                    <!-- <th style="width: 150px;" class="text-right">Remise</th> -->
                    <th style="width: 250px;" class="text-right">Prix HT Remisé (TND)</th>
                  </tr>
                </thead>
                <tbody>
                  
                     <tr v-for="(line,i) in this.order.lines" :key="i">
                      <td class="d-flex justify-content-between">
                        {{ line.ref }}
                         <img v-if="role != 0  && isFakeOrderId " src="@/assets/images/empty-set-danger.svg" alt height="15" style="cursor: pointer;" @click="resetConfirmedQuantity(line);" />
                      </td> 
                      <td>{{ line.itemTitle }}</td> 
                     
                      <td class="text-right">{{ line.price }}</td>
                      <td class="text-right">{{ line.discountedPrice }}</td>
                      <td class="text-right">{{ line.quantity }}</td>
                      <td class="text-right text-dark font-weight-bold font-size-16;" style="background-color:rgb(191, 234, 255,0.5);">
                        
                        <div v-show="!line.edit" :class="line.quantity != line.confirmedQuantity && line.confirmedQuantity != null ? 'text-danger' : ''"  @click="editConfirmedQuantity(line, i);" >
                        <!-- {{ line.confirmedQuantity != null ? line.confirmedQuantity : line.quantity }}  -->
                        {{ isCatalogList ?'':line.confirmedQuantity != null ? line.confirmedQuantity : line.quantity }}
                        <i v-if="order.isProcessable && order.status == ORDER_STATUS_SUBMITTED" class="fas fa-edit font-size-16 ml-2"  style="cursor:pointer" title="Modifier les quantités"></i>
                        </div>
                        
                        <div class="input-group input-group-sm pull-right mb-0" v-show="line.edit" >
                        <b-form-input v-model="line.confirmedQuantity" :ref="'confirmedQuantityEdit-' + i" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="saveConfirmedQuantity(line)" @blur="saveConfirmedQuantity(line)"></b-form-input>
                            <div class="input-group-append"  size="sm" >
                              <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="saveConfirmedQuantity(line)" ><i  class="fas fa-edit font-size-14"></i></b-button>
                            </div>
                        </div>

                      </td>
                      <!-- <td style="background-color: #f6d39a#83bff4; border: 1px solid;"> -->
                       
                        <td class="text-right">{{ line.lineTotalAmountBeforeDiscountStr }}</td>

                      <td class="text-right">{{ line.discountRate == 0 ? '' : line.discountRateStr + ' %' }} </td>

                      <!-- <td class="text-right">{{ line.discountAmount }}</td> -->

                     
                     

                       <!-- TODO ce calcul doit etre faut du cote serveur ou avec le bon nombre de chiffres apres la virgule -->
                      <td class="text-right">{{ line.lineTotalAmount }}</td>
                    </tr>
               
                  <tr>
                    <td colspan="8" class="border-1 text-right pt-4">
                      <strong>Total Remise</strong>
                    </td>
                    <td class="border-1 text-right pt-4">
                       <span class="m-0">{{this.order.discountAmount}} TND</span>
                    </td>
                  </tr>

                   <tr>
                    <td colspan="8" class="border-0 text-right">
                      <h5 class="m-0">Total HT</h5>
                    </td>
                    <td class="border-0 text-right">
                      <h5 class="m-0">{{this.order.total}} TND</h5>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="8" class="border-0 text-right">
                      <strong>Taxes</strong>
                    </td>
                    <td class="border-0 text-right">
                      <span class="m-0">{{this.order.taxes}} TND</span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="8" class="border-0 text-right">
                      <strong>T.V.A.</strong>
                    </td>
                    <td class="border-0 text-right">
                      <span class="m-0">{{this.order.vat}} TND</span>
                    </td>
                  </tr>

                <tr v-if=" order.isTaxStampEnabled">
                  <td colspan="8" class="border-0 text-right">
                    <strong>Timbre Fiscal</strong>
                  </td>
                  <td class="border-0 text-right">
                    <span class="m-0">{{order.taxStamp}} TND</span>
                  </td>
                </tr>

                  <tr>
                    <td colspan="8" class="border-0 text-right">
                      <h5 class="m-0">Total TTC</h5>
                    </td>
                    <td class="border-0 text-right">
                      <h5 class="m-0">{{this.order.totalWithTaxes}} TND</h5>
                    </td>
                  </tr>

                  <tr v-if="cashPaymentTotalWithTaxes" class="pt-4">
                    <!-- <td colspan="8" class="border-0 text-right text-primary">
                      <h5 class="m-0">dont </h5>
                    </td> -->
                    <td colspan="9" class="border-0 text-right">
                      <i class="m-0 text-primary font-weight-normal font-size-14">dont <strong>{{this.cashPaymentTotalWithTaxes}} TND</strong> payés au comptant</i>
                    </td>
                  </tr>


                  
                </tbody>
              </table>

              <div v-if="order.message" class="row" >
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-1 mt-4 pb-0 pl-0" style="border-top:1px solid #cccfd4;" >
                    <h4 class="card-title mb-1">Commentaire du client</h4>
                    <p class="text-muted mb-0" >
                            {{this.order.message }} </p>

                    
              </div>
              </div>

            </div>
           
          </div>
        </div>
      </div>

      



    </div>

 <div class="row pt-4 pb-4" v-if="!showCarrierModal">
      
      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
        <a href="javascript:window.print()">
            <b-button variant="light" style="width: 100%" size="lg" v-if="!isCatalogList" >
                  <i class="fa fa-print font-size-16 align-middle mr-2"></i> Imprimer
            </b-button>
          </a>
      </div>

      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
          <b-button variant="light" style="width: 100%" size="lg" @click.prevent="exportEXCEL(orderId)"  v-if="!isCatalogList" >
                <i class="fas fa-file-excel font-size-16 align-middle mr-2"></i> Exporter
          </b-button>
      </div>

      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
         <a v-if="order.carrierBarcode || order.carrierPdfLink	" href="javascript: void(0);" @click="downloadShipoxAwb();/*showCarrierModal=true*/">
            <b-button variant="light" style="width: 100%" size="lg" >
                  <i class="fas fa-truck font-size-16 align-middle mr-2"></i> Bordereau de Liv
            </b-button>
          </a>
      </div>  

      <!-- <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" />  -->

      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
        <b-button variant="info" style="width: 100%" size="lg" @click="confirm" :disabled="order.status != 1" v-if="order.isProcessable">
                 <i class="fas fa-check-double font-size-16 align-middle mr-2"></i> Confirmer
            </b-button>
      </div>

      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" >
        <b-button variant="primary" style="width: 100%" size="lg" @click="deliverOrder" :disabled="order.status != 2 || isOrderPending" v-if="order.isProcessable" >
            <b-spinner small :class="this.isOrderPending ? 'pl-2' : 'd-none'"></b-spinner>
            <i class="fas fa-truck-loading font-size-16 align-middle mr-2"></i>Livrer
        </b-button>
      </div>

      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none">
        <b-button variant="secondary" style="width: 100%" size="lg" @click="cancelOrder" :disabled="order.status != 1" v-if="!isCatalogList" >
                <i class="fas fa-exclamation-triangle font-size-16 align-middle mr-2"></i> Annuler
            </b-button>
      </div>


      


    </div>

      

  <!-- Tunisia Express Modal -->
  <b-modal v-if="order.carrierBarcode" v-model="showCarrierModal" 
   
    class="modal-fullscreen"
    
    full-screen
    

   title="Borderau de Livraison" 
        hide-footer 
        hide-header 
         
        title-class="text-warning"
        title-tag="h5"
        size="xl"
        header-close-variant="danger"
       
        >
      <div class="zoom-container">
      <div class="card border border-secondary p-4">
       <div class="row pb-4">
         <div class="col-12 text-center">
          <span class="">
              <img src="@/assets/images/logo-dark.png" alt height="35" />
            </span>
         </div>
       </div>

       <div class="row pb-4">
         <div class="col-12 text-center">
          <h4>Bordereau de Livraison N° <strong>{{order.carrierBarcode}}</strong></h4>
         </div>
       </div>

        <div class="row pt-4 pb-4">
            <div class="col-8 text-left">
              <span class="font-size-18">
                <strong>Nom Destinataire :</strong> {{this.order.customer.name}}
                <br /><strong>Adresse de Livraison :</strong> {{this.order.deliveryAddress}}
                <br /><strong>Gouvernorat :</strong> {{this.order.customer.city.name}}
                <br /><strong>Téléphone :</strong> <span v-if="order.customer.phone"> {{this.order.customer.phone}}</span>
                <span v-if="order.customer.secondPhone"> - {{this.order.customer.secondPhone}}</span>
              </span>
            </div>

            <div class="col-4 text-center">
                <img v-bind:src="'/api/image/get/barcode/' + order.carrierBarcode"  />
            </div>
        </div>

        <div class="row pt-4 pb-1">
            <div class="col-4 text-center">
              <span class="font-weight-bold font-size-18">Nombre de Colis</span>
            </div>

            <div class="col-4 text-center">
              <span class="font-weight-bold font-size-18">Date d'enlèvement</span>
            </div>

            <div class="col-4 text-center">
              <span class="font-weight-bold font-size-18">Valeur marchandise</span>
            </div>
        </div>

        <div class="row pb-4">
            <div class="col-4 text-center font-size-18">
              <span>{{this.order.parcelsNumber}}</span>
            </div>

            <div class="col-4 text-center font-size-18">
              <span>{{this.order.deliveryDate}}</span>
            </div>

            <div class="col-4 text-center font-size-18">
              <span>{{this.order.totalWithTaxes}} TND</span>
            </div>
        </div>
      </div>

      <div class="row pt-4 d-print-none">
        <div class="col-12 text-right">
          <a href="javascript:window.print()">
            <b-button variant="light" style="width: 100%" size="lg" >
                  <i class="fa fa-print font-size-16 align-middle mr-2"></i> Imprimer Le Borderau
            </b-button>
          </a>
        </div>
      </div>
      </div>
  </b-modal>
    <b-modal  
        v-model="isOrderPending" 
        hide-footer 
        hide-header 
        centered  
        no-close-on-esc   
        no-close-on-backdrop  
    >
    <div class="zoom-container">
      <div class="text-center font-size-18">Veuillez patienter pendant que nous générons votre Bordereau</div><br>
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-success" role="status">
        </div>
      </div> 
    </div>   
    </b-modal>

</div>
</template>